export function getStyle<T>(style: StyleObject<T>) {
	return Object.keys(style).reduce((acc, key) => {
		return `${acc}${key}:${style[key as keyof T]};`;
	}, '');
}

type StyleObject<T> = {
	[K in keyof T]: string;
};
